
import React from 'react'
import img2046 from '../components/images/adamazon.png'
import img2046a from '../components/images/adamazon1.png'
import img2046b from '../components/images/adamazon2.png'
import img2046c from '../components/images/adamazon3.png'
import img2046d from '../components/images/adamazon9.webp'
import img2046e from '../components/images/adamazon11.png'

const events = () => {
    return (

        <>
            <div className="row  m-2">
                <img src={img2046} alt='amazonglobal' />
            </div>
            <div className='container text-center'>
                <h2>Amazon Global Advertisement Services</h2>
                <p>
                    Drive sales and enhance brand visibility with targeted advertising on Meesho, a leading online platform connecting sellers with millions of potential customers. Utilize advanced targeting capabilities to reach your ideal audience effectively, optimize campaigns for maximum ROI, and leverage Meesho Ads’ powerful analytics for strategic insights and continuous improvement in your marketing efforts. Stay ahead in the competitive e-commerce landscape by harnessing Meesho Ads to amplify your brand’s reach and impact.
                </p>
            </div>
            <div className='container'>
                <div className='row'>
                    <h2 className='text-center' >1. Sponsored Products</h2>
                    <div className='col'>
                        <ol>
                            <li>Sponsored Products on Amazon.com are crucial for enhancing visibility in search results and product detail pages. They enable precise targeting of keywords and competitors’ ASINs, guiding potential customers directly to your product detail page. Tracking metrics such as clicks, CPC, spend, sales, and ACoS provides insights into the performance of your sponsored product campaigns. Here’s an example of a Sponsored Product ad on Amazon.com
                            </li>
                        </ol>
                    </div>
                    <div className='col'>
                        <img src={img2046a} alt='Queryimg' />
                    </div>
                </div >

                <div className='row'>
                    <h2 className='text-center' >2. Sponsored Brand Campaigns or Headline Search Ads</h2>
                    <div className='col'>
                        <ol>
                            <li>Sponsored Brand campaigns on Amazon.com feature headline search ads designed to highlight your brand through product showcases (typically three products). These campaigns utilize keyword and product targeting for optimal ad placement.

                                These ads display multiple products prominently above, below, and alongside search results on Amazon.com. You can select three products to showcase and choose specific keywords or product ASINs to target through bidding. The images of your selected products appear in search results and related product detail pages to enhance visibility and attract potential customers.</li>
                        </ol>
                    </div>
                    <div className='col'>
                        <img src={img2046b} alt='Queryimg' />
                    </div>
                </div >
                <div className='row'>
                    <h2 className='text-center' >3. Product Display Ads</h2>
                    <div className='col'>
                        <ol>
                            <li>  Product Display Ads on Amazon.com are designed to enhance product and brand visibility, focusing on cross-selling or upselling opportunities to your customer base.

                                These ads are utilized by diverse businesses, not limited to sellers, as they enable targeted audience selection for service promotion. Similar to Google Ads, they provide an alternative avenue to connect with potential customers through visual content like images and videos.

                                Product Display Ads appear prominently on Amazon.com, visible on customer review pages, product detail pages, atop the offer listing page, and below search results. Additionally, shoppers encounter these ads through various emails such as abandoned cart notifications, follow-ups, and product recommendations.</li>
                        </ol>
                    </div>
                    <div className='col'>
                        <img src={img2046c} alt='Queryimg' />
                    </div>
                </div >
                <div className='row'>
                    <h2 className='text-center' >4. Store Ads or Headline Search Ads for Stores</h2>
                    <div className='col'>
                        <ol>
                            <li>Store Ads on Amazon.com are tailored to promote a seller’s dedicated store page, a pivotal tool for showcasing their brand and full range of products.

                                Established sellers are encouraged to create an Amazon store page, offering customers a comprehensive browsing experience akin to navigating an eCommerce website. Store Ads utilize targeted keyword strategies to prominently display atop search results. Alongside highlighting the store itself, sellers can feature up to three top-selling products.</li>
                        </ol>
                    </div>
                    <div className='col'>
                        <img src={img2046d} alt='Queryimg' />
                    </div>
                </div>


                <div className='row'>
                    <h2 className='text-center' >5. Video Ads</h2>
                    <div className='col'>
                        <ol>
                            <li>   Video Ads on Amazon.com operate similarly to display ads but with video content instead of static images. Despite their potential effectiveness, video ads are often undervalued not only on Amazon but also on platforms like Google.

                                Creating compelling video ads can be challenging and they are relatively rare in the advertising landscape. Platforms like YouTube demonstrate the power of video ads with their high conversion rates.</li>
                        </ol>
                    </div>
                    <div className='col'>
                        <img src={img2046e} alt='Queryimg' />
                    </div>
                </div >
            </div >
        </>
    )
}

export default events